<template>
  <div class="flex h-fit flex-col gap-2 rounded-2xl border-4 border-neutral-600 p-4">
    <div class="relative flex w-full">
      <span class="flex-grow text-2xl">Produkte</span>
      <button @click="showProductSelect = !showProductSelect">
        <img class="m-auto w-8" src="@/assets/add.svg" />
      </button>
      <div
        v-if="showProductSelect"
        class="absolute top-9 right-1 z-50 flex flex-col gap-2 rounded-xl bg-neutral-600 p-2"
      >
        <div class="fixed inset-0 z-40 h-full w-full" @click="showProductSelect = false"></div>
        <button
          class="z-50 rounded-lg bg-neutral-500 p-1"
          v-for="item in dataStore.products.filter(
            (x) => boughtProducts.findIndex((y) => y.id == x.id) < 0,
          )"
          :key="'products_' + item.id"
          @click="
            boughtProducts.push({ id: item.id, count: 1 });
            showProductSelect = false;
            dataStore.update();
          "
        >
          {{ item.name }}
        </button>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th class="w-64 p-1">Name</th>
          <th class="w-20 p-1">Preis [€]</th>
          <th class="w-20 p-1">Anzahl</th>
          <th class="p-1"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in boughtProducts" :key="'productsBought_' + product.id">
          <td>{{ dataStore.products.find((x) => x.id == product.id)!.name }}</td>
          <td class="text-center">
            {{ dataStore.products.find((x) => x.id == product.id)!.price }} €
          </td>
          <td>
            <input
              type="number"
              min="1"
              class="w-20"
              v-model="product.count"
              @change="dataStore.update()"
            />
          </td>
          <td>
            <button
              class="m-1 rounded-lg bg-neutral-600 px-1 hover:bg-neutral-500"
              @click="
                boughtProducts.splice(boughtProducts.indexOf(product), 1);
                dataStore.update();
              "
            >
              X
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="boughtProducts.length">
        <tr>
          <td></td>
          <td>Summe:</td>
          <td>{{ dataStore.getProductSum(boughtProducts) }} €</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script setup lang="ts">
import { type boughtProductsT, type entry } from "@/types";
import { useStore } from "../stores/dataStore";
import { ref } from "vue";
const dataStore = useStore();

const props = defineProps<{
  boughtProducts: boughtProductsT[];
}>();

const showProductSelect = ref(false);
</script>

<style scoped>
th:not(:first-child),
td:not(:first-child) {
  border-left: 1px solid black;
}
</style>
